import styled from '@emotion/styled';
import { LinkBox } from '@hover/blueprint/chakra';
import { Box } from '@hover/blueprint';

export const StyledLinkBox = styled(LinkBox)`
  transition: all 0.1s ease-in;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  flex-direction: column;
`;

export const StyledDescription = styled(Box)`
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  height: 100%;
`;
